import ApplicationComponent from "legacy/ApplicationComponent"
import DatePicker from "legacy/DatePicker"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class AssignmentsFilterBar extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.loadViewType = this.loadViewType.bind(this)
    this.datePickerChange = this.datePickerChange.bind(this)
    this.spaceFilterChange = this.spaceFilterChange.bind(this)
  }

  loadViewType(event) {
    const view = event.target.value
    if (view === "electric") {
      window.location.href = this.props.meteredElectricPath
    } else {
      this.props.setViewType(view)
    }
  }

  spaceFilterChange(event) {
    switch (event.target.value) {
      case "with_assignments":
        Amplitude.trackEvent("assignments:filter_assigned")
        break
      case "without_assignments":
        Amplitude.trackEvent("assignments:filter_no_assigned")
    }
    this.props.onChange(event)
  }

  visibleSpacesWidth() {
    if (this.props.visibleSpaces === "all") {
      return 70
    } else if (this.props.visibleSpaces === "with_assignments") {
      return 170
    } else {
      return 190
    }
  }

  datePickerChange(date) {
    if (date !== this.props.datePickerDate.format("MM/DD/YYYY")) {
      this.props.dateChange(moment(date, "MM/DD/YYYY"))
    }
  }

  unassignedReservationBadge(additionalClasses = "") {
    if (this.props.unassignedReservationsCount === 0) return null

    return (
      <div className={`badge badge-red rounded-full ${additionalClasses}`}>
        {this.props.unassignedReservationsCount}
      </div>
    )
  }

  isSmallDevice() {
    // sadly we can't use a css util here because select options don't work that way
    return (
      Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      ) < 1280
    )
  }

  renderSpaceFilter() {
    return (
      <div className="flex items-center">
        <strong>Spaces: </strong>
        <select
          className="form-control inline-block border-0 bg-transparent"
          name="visibleSpaces"
          value={this.props.visibleSpaces}
          onChange={this.spaceFilterChange}
          style={{ width: this.visibleSpacesWidth() }}
        >
          <option value="all">All</option>
          <option value="with_assignments">With Assignments</option>
          <option value="without_assignments">Without Assignments</option>
        </select>
      </div>
    )
  }

  renderAddButtonGroup() {
    return (
      <div className="btn-group hidden md:block xl:hidden">
        <button
          type="button"
          className="btn btn-secondary dropdown-toggle relative"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Add
          <i className="fa-kit fa-plus-circle ml-2" />
        </button>
        <ul className="dropdown-menu dropdown-menu-right">
          <li>
            <a
              className="flex items-center py-2"
              href="#"
              onClick={this.props.openUnassignedReservations}
            >
              <i className="fa-kit fa-fw fa-assignment mr-1" />
              Assign Reservations
              {this.unassignedReservationBadge("ml-1")}
            </a>
          </li>
          <li>
            <a
              className="py-2"
              href="#"
              onClick={this.props.openAddPlaceholder}
            >
              <i className="fa-kit fa-fw fa-thumb-tack mr-1" />
              Add Placeholder
            </a>
          </li>
          <li>
            <a className="py-2" href="#" onClick={this.props.openAddNote}>
              <i className="fa-kit fa-fw fa-clipboard-pencil mr-1" />
              Add Note
            </a>
          </li>
        </ul>
      </div>
    )
  }

  render() {
    return (
      <div
        className="z-40 flex flex-wrap p-4 md:sticky md:top-0 md:items-end"
        style={{ backgroundColor: "#F1F5F8", marginTop: -15 }}
      >
        <div className="flex flex-row">
          <div className="ml-3 mr-5 flex items-center">
            <strong>View:</strong>
            <select
              className="form-control border-0 bg-transparent"
              style={{ width: 185 }}
              name="viewType"
              value={this.props.viewType}
              onChange={this.loadViewType}
            >
              {$context.hasDockwalk && (
                <option value="dockwalk">Dockwalk</option>
              )}
              {$context.hasDockwalk && (
                <option value="dockwalkSummary">Dockwalk Summary</option>
              )}
              <option value="weekly">Weekly</option>
              <option hidden={this.isSmallDevice()} value="monthly">
                Monthly
              </option>
              {$context.hasMeteredElectric &&
                this.props.meteredElectricPath && (
                  <option value="electric">Electric</option>
                )}
              {this.props.marinaMaps.map((marinaMap, index) => {
                return (
                  <option key={index} value={`map:${marinaMap.id}`}>
                    {marinaMap.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="mr-3 flex items-center">
            <strong>Jump to: </strong>
            <div style={{ maxWidth: 135 }}>
              <div className="form-control-with-icon">
                <i
                  className="fa-kit fa-sort-desc form-control-icon-right"
                  style={{ marginTop: -3, right: "1.5em" }}
                />
                <DatePicker
                  name="date"
                  setParentState={this.datePickerChange}
                  value={
                    this.props.datePickerDate &&
                    moment(this.props.datePickerDate).format("MM/DD/YYYY")
                  }
                  orientation="top"
                  className="border-0 bg-transparent"
                />
              </div>
            </div>
          </div>
          {this.props.viewType &&
            !this.props.viewType.includes("map") &&
            this.props.viewType !== "dockwalkSummary" &&
            this.renderSpaceFilter()}
          {this.props.loadingGrid ? (
            <span className="text-muted ml-5">
              Loading
              <i className="fa-kit fa-spinner fa-spin h5 ml-3" />
            </span>
          ) : null}
        </div>
        <div className="ml-auto">
          {this.props.viewType !== "dockwalkSummary" &&
            this.renderAddButtonGroup()}
          {this.props.viewType !== "dockwalkSummary" ? (
            <div className="hidden xl:flex xl:space-x-2">
              <button
                className={`btn relative ${
                  this.props.sidebarView === "unassigned"
                    ? "btn-primary"
                    : "btn-secondary"
                }`}
                type="button"
                onClick={this.props.openUnassignedReservations}
              >
                {this.unassignedReservationBadge(
                  "absolute top-0 right-0 -mt-2 -mr-1"
                )}
                {this.props.sidebarView === "unassigned" ? (
                  <i className="fa-kit fa-fw fa-cancel mr-1" />
                ) : (
                  <i className="fa-kit fa-fw fa-assignment mr-1" />
                )}
                Assign Reservations
              </button>
              <button
                className={`btn ${
                  this.props.sidebarView === "placeholder"
                    ? "btn-primary"
                    : "btn-secondary"
                }`}
                type="button"
                onClick={this.props.openAddPlaceholder}
              >
                {this.props.sidebarView === "placeholder" ? (
                  <i className="fa-kit fa-fw fa-cancel mr-1" />
                ) : (
                  <i className="fa-kit fa-fw fa-thumb-tack mr-1" />
                )}
                Add Placeholder
              </button>
              <button
                className={`btn ${
                  this.props.sidebarView === "note"
                    ? "btn-primary"
                    : "btn-secondary"
                }`}
                type="button"
                onClick={this.props.openAddNote}
              >
                {this.props.sidebarView === "note" ? (
                  <i className="fa-kit fa-fw fa-cancel mr-1" />
                ) : (
                  <i className="fa-kit fa-fw fa-clipboard-pencil mr-1" />
                )}
                Add Note
              </button>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

AssignmentsFilterBar.propTypes = {
  dateChange: PropTypes.func.isRequired,
  datePickerDate: PropTypes.object.isRequired,
  handleMarinaMapSpaceClick: PropTypes.func.isRequired,
  loadingGrid: PropTypes.bool,
  marinaMaps: PropTypes.array.isRequired,
  meteredElectricPath: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  openAddPlaceholder: PropTypes.func.isRequired,
  openAddNote: PropTypes.func.isRequired,
  openUnassignedReservations: PropTypes.func.isRequired,
  setViewType: PropTypes.func.isRequired,
  sidebarView: PropTypes.string,
  unassignedReservationsCount: PropTypes.number.isRequired,
  viewType: PropTypes.string.isRequired,
  visibleSpaces: PropTypes.string.isRequired,
}

export default AssignmentsFilterBar
